/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tasks_Status_UnderwayInputs */

const en_tasks_status_underway = /** @type {(inputs: Tasks_Status_UnderwayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Underway`)
};

const fr_tasks_status_underway = /** @type {(inputs: Tasks_Status_UnderwayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En cours`)
};

const ms_sg2_tasks_status_underway = /** @type {(inputs: Tasks_Status_UnderwayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sedang dijalankan`)
};

/**
* | output |
* | --- |
* | "Underway" |
*
* @param {Tasks_Status_UnderwayInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const tasks_status_underway = /** @type {((inputs?: Tasks_Status_UnderwayInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tasks_Status_UnderwayInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tasks_status_underway(inputs)
	if (locale === "fr") return fr_tasks_status_underway(inputs)
	return ms_sg2_tasks_status_underway(inputs)
});